import { useNavigate } from 'react-router-dom';
import { useUI } from '@/context/UIContext';
import { useSettings } from '@/hooks/queries';
import { Drawer } from './Drawer';

export function MenuDrawer() {
  const { drawer, closeDrawer, openDrawer } = useUI();
  const navigate = useNavigate();
  const { data: settings } = useSettings();
  const go = (path: string) => { closeDrawer(); navigate(path); };

  return (
    <Drawer side="menu" title="Menu" open={drawer === 'menu'} onClose={closeDrawer}>
      <nav aria-label="Main">
        <button onClick={() => go('/')}>The rail</button>
        <button onClick={() => go('/?view=grid')}>All pieces</button>
        <button onClick={() => { closeDrawer(); window.setTimeout(() => openDrawer('cart'), 300); }}>Your bag</button>
      </nav>
      <p className="small">{settings?.siteName || 'We'} is a small clothing studio. Every piece on the rail is made in runs of 60 or fewer.</p>
    </Drawer>
  );
}
